import { SlackNotifySettings, SlackNotifySettingsPatch } from '../../Model/SlackNotifySettings';
import { AccountRepository } from '../Repositories/AccountRepository';

export class UpdateSlackNotifySettingsUseCase {
  constructor(private readonly repo: AccountRepository) {}

  execute(dto: SlackNotifySettingsPatch): Promise<SlackNotifySettings> {
    return this.repo.updateSlackNotifySettings(dto);
  }
}
